/** Zero-pads to two digits for the timestamp parts. */
const pad = (n: number): string => String(n).padStart(2, "0");

/**
 * Local day-and-time stamp, e.g. "2026-09-09_15-30-12".
 *
 */
export const exportTimestamp = (now: Date = new Date()): string =>
  `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}` +
  `_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`;

/** Filename (without extension) for any Site Library export. */
export const buildExportFileName = (now: Date = new Date()): string =>
  `CA_Modbus_mapping_library_${exportTimestamp(now)}`;

/**
 * Makes an imported name unique by appending a date suffix when it collides.
 *
 */
export const dedupeImportedName = (
  name: string,
  taken: Set<string>,
  now: Date = new Date(),
): string => {
  const trimmed = (name ?? "").trim();
  const key = trimmed.toLowerCase();
  if (!trimmed || !taken.has(key)) {
    return trimmed;
  }

  const stamped = `${trimmed}_${exportTimestamp(now)}`;
  if (!taken.has(stamped.toLowerCase())) {
    return stamped;
  }

  // Same name twice inside one file imported within the same second: the stamp
  // alone is not enough, so fall back to a counter on top of it.
  let suffix = 2;
  while (taken.has(`${stamped}_${suffix}`.toLowerCase())) {
    suffix++;
  }
  return `${stamped}_${suffix}`;
};
